import { Component } from '@angular/core';
import { smoothlyMenu } from '../../../app.helpers';
import { AuthService } from '../../../auth/auth.service';
import { LoggedInUser, LoggedInUserService } from '../../../auth/logged.in.user';
import { Configuration } from '../../../configuration';
import { CmsDialogDto } from '../../../models/cms.dialogs/cms.dialogs.models';
import { CmsHelpService } from '../../../services/cms.help.service';
import { CmsDialogService } from '../../../services/cms.dialog.service';
import { RouterService } from '../../../services/routerService';
import { PermissionsHub } from '../../../signalr/permissions.hub';
import { HelpDialogComponent } from './help.dialog.component';
import { AccountService } from '../../../services/account.service';
import { CustomerNewFeaturesDto } from '../../../models/account/account.models';
import { MatDialog } from '@angular/material/dialog';
import { PaidFeatureUpsellService } from '../../../services/paid.feature.upsell.service';
require('metismenu');

type NavContext = 'tenders' | 'awards' | 'training' | 'alertsProfile' | 'help' | 'bidManagement';

@Component({
    selector: 'navigation',
    template: require('./navigation.component.html'),
    styles: [require('./navigation.component.css')]
})

export class NavigationComponent {
    loggedInUser: LoggedInUser;
    fullname: string;
    publicFacingUrl: string;
    sharedBookmarkedTendersDialogHeader: string;
    tendersSentToBidManagementDialogHeader: string;
    tendersSentToBidManagementDialogBody: string;
    sharedBookmarkedTendersDialogBody: string;
    subscribed: boolean;
    supplierStatus: string;
    newFeatures: Array<CustomerNewFeaturesDto>;
    isBidManager: boolean;
    bidManagementUrl: string;

    get navContext(): NavContext {
        const url = (this.router && this.router.router && this.router.router.url ? this.router.router.url : '').toLowerCase();

        if (url.indexOf('/help') > -1) {
            return 'help';
        }

        if (url.indexOf('/tenders') > -1) {
            return 'tenders';
        }

        if (
            url.indexOf('/contractawards') > -1 ||
            url.indexOf('/competitors') > -1 ||
            url.indexOf('/competitornotice') > -1 ||
            url.indexOf('/resources') > -1
        ) {
            return 'awards';
        }

        if (url.indexOf('/training') > -1) {
            return 'training';
        }

        if (
            url.indexOf('/viewaccount') > -1 ||
            url.indexOf('/account/') > -1 ||
            url.indexOf('/tenderalertprofile') > -1 ||
            url.indexOf('/teammembers') > -1
        ) {
            return 'alertsProfile';
        }

        if (url.indexOf('/bidmanagement') > -1) {
            return 'bidManagement';
        }

        return 'tenders';
    }

    constructor(public userService: LoggedInUserService, private helpService: CmsHelpService,
        private router: RouterService, private authService: AuthService,
        private readonly configuration: Configuration, public dialog: MatDialog, private readonly cmsDialogService: CmsDialogService,
        private readonly accountService: AccountService, private readonly paidFeatureUpsellService: PaidFeatureUpsellService) {
        this.fullname = '';
        this.supplierStatus = '';
        this.loggedInUser = this.userService.getCurrentUser();
        if (this.loggedInUser != null) {
            this.fullname = this.loggedInUser.fullName;
            this.isBidManager = this.loggedInUser.canAdHoc('bidManagerDashboard');
            this.subscribed = !this.loggedInUser.canAdHoc('notSubscribed');

            if (this.subscribed) {
                if (this.teamMember()) {
                    this.supplierStatus = 'Team member';
                }
                else {
                    this.supplierStatus = 'Tender Manager';
                }
            }
            else {
                this.supplierStatus = 'Free';
            }

            this.accountService.getNewFeatures().subscribe((result: any) => {
                this.newFeatures = result.value;
            });
            
        } else {
            this.router.router.navigate(['/account/login']);
        }

        this.publicFacingUrl = configuration.routing.publicFacingUrl;
        this.bidManagementUrl = configuration.routing.bidManagementUrl;
        $('#not-subscribed-modal').modal();
        $('#not-subscribed-modal').modal('hide');
    }

    ngOnInit() {

        PermissionsHub.startHub(this.authService, this.configuration, this.loggedInUser.userId);

        this.cmsDialogService.getByDescription('Shared Bookmarked Tenders').subscribe((result: CmsDialogDto) => {
            this.sharedBookmarkedTendersDialogHeader = result.header;
            this.sharedBookmarkedTendersDialogBody = result.body;
        });
        this.cmsDialogService.getByDescription('Tenders Sent to Bid Management - Not Subscribed').subscribe((result: CmsDialogDto) => {
            this.tendersSentToBidManagementDialogHeader = result.header;
            this.tendersSentToBidManagementDialogBody = result.body;
        });
    }

    ngAfterViewInit() {
        $('#side-menu').metisMenu();

        $('.links-block .links_title').click(function () {
            $(this).parent().toggleClass('expanded');
            $(this).parent().find('.collapse').slideToggle();
            $(this).parent().siblings().find('.collapse').slideUp();
            $(this).parent().siblings().removeClass('expanded');
        });
    }

    activeRoute(routename: string): boolean {
        return this.router.router.url.indexOf(routename) > -1;
    }

    showPaidFeatureUpsellModal() {
        this.paidFeatureUpsellService.openDefault();
    }

    showNotSubscribedSharedBookmarkedTenderModal() {
        $('#not-subscribed-sharedBookmarkedTenders-modal').modal();
    }

    showNotSubscribedTendersSentToBidManagementModal() {
        $('#not-subscribed-tendersSentToBidManagement-modal').modal();
    }

    toggleNavigation() {
        $('.sidebar-nav-fullscreen-close').toggleClass('active');
        $('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }

    logout() {
        this.authService.logout();
    }

    openHelpDialog() {
        let helpText: string = '';
        this.helpService.getByUser(this.loggedInUser.userId).subscribe((result) => {
            let dialogRef = this.dialog.open(HelpDialogComponent, {
                width: '50%',
                data: result,
                position: {
                    top: '50px',
                    left: '182px'
                }
            });
        });
    }

    teamMember(): boolean {
        return (this.loggedInUser.role != 'Supplier');
    }

    showNew(id: number): boolean {
        if (this.newFeatures == null || this.newFeatures == undefined) {
            return false;
        }

        if (this.newFeatures.some(e => e.newFeatureId === id && !e.alreadySeen)) {
            return true;
        }
        else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/navigation/navigation.component.ts